import * as baseService from "./base";
import { config } from "../configs";

export let workEventId;
export let workItemId;
export let stepNum;
export let configuration;
export let authToken;

// Will need to define app as well
export let organization;
export let application;

/**
 * Gets the optional procedure step configuration or undefined if no configuration.
 *
 * @returns {Object}
 */
export function getConfiguration() {}

/**
 * Gets the current authToken.
 *
 * @returns {string}
 */
export function getAuthToken() {}


// init
export async function configure(config = {}) {
  workEventId = config?.workEventId;
  workItemId = config?.workItemId;
  stepNum = config?.stepNum;
  organization = config?.organization;
  application = config?.application;
  authToken = config?.authToken;
}

/**
 * Saves a result file for the procedure step.
 *
 * @param {(Blob|File)} data  The file contents.
 * @param {string} [name]  The saved filename.  If not supplied, will use File.name property.
 * @param {string} [type]  the MIME type.  If not supplied will use the Blob.type or File.type property.
 */
export async function putFile(data, name, type) {
  const URL = `${config.baseURL}/workevents/${workEventId}/workitems/${workItemId}/steps/${stepNum}/resulturls/put/${name}`;
  let response = await baseService.makeFetch(URL, {
    method: "GET",
    headers: new Headers({
      Authorization: authToken,
      Application: application,
      Organization: organization,
    }),
  });
  if (response.ok) {
    let { url } = await response.json();
    const blobResponse = await baseService.makeFetch(url, {
      method: "PUT",
      body: data,
      headers: new Headers({
        "Content-Type": type || "binary/octet-stream",
      }),
    });
    return blobResponse.statusText;
  } else if (response.status === 401) {
    let json = await response.json();
    throw json;
  }
}

/**
 * Retrievea a result file for the procedure step as a Blob.
 *
 * @param {string} name  The name of the file to retrieve.
 * @returns {Blob}
 */
export async function getFileAsBlob(name) {
  const URL = `${config.baseURL}/workevents/${workEventId}/workitems/${workItemId}/steps/${stepNum}/resulturls/get/${name}`;
  let response = await baseService.makeFetch(URL, {
    method: "GET",
    headers: new Headers({
      Authorization: authToken,
      Application: application,
      Organization: organization,
    }),
  });
  if (response.ok) {
    let { url } = await response.json();

    const blobResponse = await baseService.makeFetch(url, {
      method: "GET",
      headers: new Headers({}),
    });
    return blobResponse.blob();
  } else if (response.status === 401) {
    let json = await response.json();
    throw json;
  }
}

/**
 * Retrievea a result JSON file for the procedure step as an Object.
 *
 * @param {string} name  The name of the file to retrieve.
 * @returns {Object}
 */
export async function getFileAsObject(name) {
  const URL = `${config.baseURL}/workevents/${workEventId}/workitems/${workItemId}/steps/${stepNum}/resulturls/get/${name}`;
  let response = await baseService.makeFetch(URL, {
    method: "GET",
    headers: new Headers({
      Authorization: authToken,
      Application: application,
      Organization: organization,
    }),
  });
  if (response.ok) {
    let { url } = await response.json();
    const objectResponse = await baseService.makeFetch(url, {
      method: "GET",
      headers: new Headers({}),
    });
    if (objectResponse.ok) {
      let contentType = objectResponse.headers.get("Content-Type");
  
      if (contentType?.indexOf("application/json") > -1) {
        return objectResponse.json();
      }
  
      return response.statusText;
    }
    throw response;
  } else if (response.status === 401) {
    let json = await response.json();
    throw json;
  }
}

/**
 * Deletes a result file for the procedure step.
 *
 * @param {string} name  The name of the file to delete.
 */
export async function deleteFile(name) {
  const URL = `${config.baseURL}/workevents/${workEventId}/workitems/${workItemId}/steps/${stepNum}/resulturls/delete/${name}`;
  let response = await baseService.makeFetch(URL, {
    method: "GET",
    headers: new Headers({
      Authorization: authToken,
      Application: application,
      Organization: organization,
    }),
  });
  if (response.ok) {
    let { url } = await response.json();
    return baseService.destroy(url);
  } else if (response.status === 401) {
    let json = await response.json();
    throw json;
  }
}

/**
 * Lists names of existing result files for the procedure step.
 *
 * @returns {string[]}
 */
export async function listFiles() {
  const URL = `${config.baseURL}/workevents/${workEventId}/workitems/${workItemId}/steps/${stepNum}/resultkeys`;
  let response = await baseService.makeFetch(URL, {
    method: "GET",
    headers: new Headers({
      Authorization: authToken,
      Application: application,
      Organization: organization,
    }),
  });
  if (response.ok) {
    let json = await response.json();
    return json;
  } else if (response.status === 401) {
    let json = await response.json();
    throw json;
  }
}

/**
 * Marks the procedure step as STARTED.
 */
export async function setCompleted() {}

/**
 * Marks the procedure step as COMPLETED.
 */
export async function setStarted() {}

/**
 * Adds or updates the specified result attribute for the work item.
 */
export async function setResultAttribute(name, value) {}

/**
 * Gets the value of a result attribute for the work item.
 *
 * @returns {string}
 */
export async function getResultAttribute(name) {}

/**
 * Deletes a result attribute for the work item.
 */
export async function deleteResultAttribute(name) {}
